// PAINEL CEO -- o mesmo desenho do 38 Brasil.
//
// Sete sub-abas, na ordem em que ele usa:
//
//   Operacao          contas, vendas, receita do dia / do periodo / total,
//                     busca de usuario, suporte, historico
//   Controle do jogo  preco e ligas gratis, sem novo deploy
//   Avisos            o recado que aparece uma vez para todo mundo
//   Tela inicial      a chamada FIXA da home (fica ate ser tirada)
//   Promocoes         preco menor com prazo
//   Enquetes          pergunta para os jogadores, com apuracao
//   Bugs              o que os jogadores relataram
//
// So aparece para quem esta em CEO_EMAILS no servidor. Para todo o resto a
// rota responde 404 -- nem existe. Um painel administrativo que responde 403
// conta que existe algo ali.

import React, { useEffect, useState } from 'react';
import {
  fetchCeoStats, ceoGrant, ceoConfig, ceoAviso, ceoBuscar, ceoSenha,
  ceoTelaInicial, ceoPromo, ceoEnquete, ceoBug, ceoZerarReceita, readAccount, apiUrl,
} from './api.js';
import { LEAGUE_LIST } from '../data/leagues.js';

/**
 * Dinheiro DE VERDADE, em reais.
 *
 * O `money()` do jogo fala em milhoes -- e o caixa de um clube, nao a receita
 * do negocio. Usar aquele aqui transformava R$ 19,90 em "R$ 19.9 mi" e R$ 0,00
 * em "R$ 0 mil".
 */
const brl = (v) => Number(v || 0).toLocaleString('pt-BR', {
  style: 'currency', currency: 'BRL',
});

/**
 * 'AAAA-MM-DD' para '07/09/2026'.
 *
 * ⚠️ NAO passa por `new Date()`. `new Date('2026-09-07')` e lido como
 * meia-noite UTC, que no Brasil e 21h do dia 6 -- a data apareceria UM DIA
 * ATRASADA na tela. E exatamente o defeito de fuso que o painel teve ate
 * 05/09/2026, e ele voltaria aqui pela porta da formatacao. Recortar os
 * numeros da string nao tem esse problema porque nao existe fuso envolvido.
 */
const dataBR = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
  return m ? `${m[3]}/${m[2]}/${m[1]}` : String(iso || '-');
};

const dataCurta = (iso) => (iso ? new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) : '-');
const dataHora = (iso) => (iso
  ? new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
  : '-');
const mesNome = (m) => {
  const [ano, mes] = m.split('-');
  const nomes = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  return `${nomes[Number(mes) - 1]}/${ano.slice(2)}`;
};

/** Cartao de numero grande -- e assim que ele le o painel no celular. */
function Kpi({ k, v, sub, tom }) {
  return (
    <div className={`ceo-kpi ${tom || ''}`}>
      <div className="k">{k}</div>
      <div className="v">{v}</div>
      {sub && <div className="s">{sub}</div>}
    </div>
  );
}

/**
 * O print de um relato.
 *
 * ⚠️ BUSCADO POR `fetch`, e nao posto direto num `<img src>`.
 * A rota do print exige o cabecalho de autorizacao -- e um `<img>` nao manda
 * cabecalho nenhum. Apontar o `src` para ela devolveria 404 em toda imagem, e
 * o painel mostraria um icone quebrado sem dizer por que. Aqui a imagem vem
 * pelo fetch (com o token), vira um blob local, e so entao entra no `<img>`.
 */
function PrintDoRelato({ id }) {
  const [url, setUrl] = useState(null);
  const [falhou, setFalhou] = useState(false);

  useEffect(() => {
    let vivo = true;
    let criada = null;
    fetch(apiUrl(`/api/ceo/bug-imagem/${id}`), {
      headers: { authorization: `Bearer ${readAccount()?.token}` },
    })
      .then((r) => (r.ok ? r.blob() : Promise.reject(new Error('sem print'))))
      .then((b) => {
        if (!vivo) return;
        criada = URL.createObjectURL(b);
        setUrl(criada);
      })
      .catch(() => { if (vivo) setFalhou(true); });
    /* Revoga ao desmontar: cada blob segura memoria ate ser liberado, e a aba
       de bugs redesenha a cada "resolvido". */
    return () => { vivo = false; if (criada) URL.revokeObjectURL(criada); };
  }, [id]);

  if (falhou) return <div className="small dim" style={{ marginTop: 6 }}>print indisponivel</div>;
  if (!url) return <div className="small dim" style={{ marginTop: 6 }}>carregando print...</div>;
  return (
    <a className="ceo-bug-print" href={url} target="_blank" rel="noreferrer"
      title="abrir o print em tamanho real">
      <img src={url} alt="print do relato" />
    </a>
  );
}

/** Uma conta na lista. O mesmo cartao serve na busca e nas contas recentes. */
function LinhaConta({ c, busy, onGrant, onSenha }) {
  return (
    <div className="ceo-user">
      <div style={{ minWidth: 0 }}>
        <div className="ceo-user-t">{c.nome || c.email}</div>
        {c.nome && <div className="ceo-user-s">{c.email}</div>}
        <div className="ceo-user-s">
          {c.whatsapp ? `${c.whatsapp} · ` : ''}
          entrou em {dataCurta(c.createdAt)}
          {c.premium ? ` · premium em ${dataCurta(c.premiumAt)}` : ''}
          {c.temSaveNaNuvem ? ' · save na nuvem' : ''}
        </div>
      </div>
      <div className="ceo-user-acoes">
        <span className={`pill ${c.premium ? 'on' : ''}`}>
          {!c.premium ? 'free' : c.origem === 'concedido' ? 'concedido' : 'pago'}
        </span>
        <button className="ghost sm" disabled={busy} onClick={() => onGrant(c)}>
          {c.premium ? 'tirar' : 'liberar'}
        </button>
        {onSenha && (
          <button className="ghost sm" disabled={busy} onClick={() => onSenha(c)}>senha</button>
        )}
      </div>
    </div>
  );
}

export function CeoPanel({ onBack }) {
  const [aba, setAba] = useState('ops');
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [busy, setBusy] = useState(false);
  const [feito, setFeito] = useState('');

  // Suporte / busca
  const [termo, setTermo] = useState('');
  const [achados, setAchados] = useState(null);
  const [alvo, setAlvo] = useState('');

  // Controle do jogo
  const [preco, setPreco] = useState('');
  const [gratis, setGratis] = useState([]);

  // Avisos e tela inicial
  const [avisoTitulo, setAvisoTitulo] = useState('');
  const [avisoTexto, setAvisoTexto] = useState('');
  const [homeTitulo, setHomeTitulo] = useState('');
  const [homeTexto, setHomeTexto] = useState('');

  // Promocao
  const [promoPreco, setPromoPreco] = useState('');
  const [promoAte, setPromoAte] = useState('');
  const [promoTexto, setPromoTexto] = useState('');

  // Enquete
  const [pergunta, setPergunta] = useState('');
  const [opcoes, setOpcoes] = useState(['', '', '', '']);

  const carregar = async () => {
    const conta = readAccount();
    if (!conta?.token) { setErro('Entre na sua conta.'); return; }
    setBusy(true); setErro('');
    try {
      const d = await fetchCeoStats(conta.token);
      setDados(d);
      setPreco(String(d.config?.preco ?? d.totais.preco));
      setGratis(d.config?.ligasGratis ?? ['nbb']);
      setAvisoTitulo(d.aviso?.titulo || '');
      setAvisoTexto(d.aviso?.texto || '');
      setHomeTitulo(d.telaInicial?.titulo || '');
      setHomeTexto(d.telaInicial?.texto || '');
      setPromoPreco(d.promo ? String(d.promo.preco) : '');
      setPromoAte(d.promo?.ate || '');
      setPromoTexto(d.promo?.texto || '');
      if (d.enquete) {
        setPergunta(d.enquete.pergunta);
        setOpcoes([...d.enquete.opcoes, '', '', '', ''].slice(0, 4));
      }
    } catch (e) { setErro(e.message); }
    setBusy(false);
  };

  useEffect(() => { carregar(); }, []);

  const acao = async (fn, msg) => {
    setBusy(true); setFeito(''); setErro('');
    try { await fn(); await carregar(); setFeito(msg); setTimeout(() => setFeito(''), 3500); }
    catch (e) { setErro(e.message); }
    setBusy(false);
  };

  const token = () => readAccount().token;

  const buscar = async () => {
    setBusy(true); setErro('');
    try { setAchados(await ceoBuscar(token(), termo)); }
    catch (e) { setErro(e.message); setAchados(null); }
    setBusy(false);
  };

  // Senha nova pelo suporte: o dono digita o valor. Sortear uma aqui seria
  // pior -- ele precisa poder ditar a senha no WhatsApp para a pessoa.
  const trocarSenhaDe = (c) => {
    const nova = window.prompt(`Senha nova para ${c.email} (pelo menos 6 caracteres):`);
    if (!nova) return;
    acao(() => ceoSenha(token(), c.email, nova), `Senha de ${c.email} trocada.`);
  };

  const alternarPremium = (c) =>
    acao(() => ceoGrant(token(), c.email, !c.premium),
      c.premium ? 'Premium removido.' : 'Premium liberado.');

  const zerar = () => {
    if (!window.confirm(
      'Fechar o periodo de receita?\n\n'
      + 'Nada e apagado: as vendas continuam no historico e ninguem perde o premium. '
      + 'O que reinicia e o contador do periodo.',
    )) return;
    acao(() => ceoZerarReceita(token()), 'Periodo fechado e arquivado.');
  };

  const t = dados?.totais;
  const maxDia = dados?.dias?.length ? Math.max(...dados.dias.map((d) => d.contas), 1) : 1;
  const maxMes = dados?.receitaPorMes?.length ? Math.max(...dados.receitaPorMes.map((m) => m.receita), 1) : 1;
  const votosMax = dados?.enquete?.apuracao?.length
    ? Math.max(...dados.enquete.apuracao.map((o) => o.votos), 1) : 1;

  const ABAS = [
    ['ops', 'Operacao'], ['game', 'Controle do jogo'], ['avisos', 'Avisos'],
    ['home', 'Tela inicial'], ['promo', 'Promocoes'], ['enquete', 'Enquetes'],
    ['bugs', `Bugs${t?.bugsAbertos ? ` (${t.bugsAbertos})` : ''}`],
  ];

  return (
    <>
      <div className="topbar">
        <div className="inner">
          <div className="row" style={{ gap: 8 }}>
            <button className="ghost sm" onClick={onBack}>voltar</button>
            <div className="brand">painel <b>CEO</b></div>
          </div>
          <div className="meta">
            {dados ? `${dados.ambiente} · ${dataBR(dados.hoje)}` : ''}
          </div>
        </div>
      </div>

      <div className="wrap">
        <div className="card ceo-head">
          <div style={{ minWidth: 0 }}>
            <p className="kicker">• Administracao</p>
            <h1 style={{ margin: '2px 0' }}>Painel CEO</h1>
            <div className="small dim">Vendas, contas, receita e suporte do 82 Basquete.</div>
          </div>
          <div className="ceo-acoes">
            <button className="ceo-acao on" disabled={busy} onClick={carregar}>atualizar</button>
            <button className="ceo-acao" disabled={busy} onClick={zerar}>zerar receita</button>
          </div>
        </div>

        <div className="ceo-tabs">
          {ABAS.map(([id, label]) => (
            <button key={id} className={aba === id ? 'on' : ''} onClick={() => setAba(id)}>{label}</button>
          ))}
        </div>

        {erro && <div className="card tight neg small">{erro}</div>}
        {feito && <div className="card tight pos small">{feito}</div>}
        {!dados && !erro && <div className="card dim small">Carregando...</div>}

        {/* ------------------------------------------------------ OPERACAO */}
        {dados && aba === 'ops' && (
          <>
            <h2 className="ceo-secao">Receita</h2>
            {/* O dia vira a MEIA-NOITE de Brasilia. Ja virou as 21h, quando a
                conta era feita em UTC -- dizer o fuso na tela e o que impede a
                duvida de voltar. */}
            <div className="card ceo-hoje">
              {/* ⚠️ O fuso saiu da barra de cima -- 'America/Sao_Paulo' nao cabe
                  ao lado do ambiente e da data, e cortava no celular. Mas ele
                  nao pode simplesmente sumir: e o que impede a duvida de
                  'que dia e esse?' de voltar. Vive aqui, no titulo da
                  etiqueta, a um toque de distancia e sem ocupar espaco. */}
              {/* ⚠️ O fuso saiu da barra de cima: "America/Sao_Paulo" nao cabia
                  ao lado do ambiente e da data, e cortava no celular. Mas ele
                  nao podia simplesmente sumir -- e o que impede a duvida de
                  "que dia e esse?" de voltar. Mora aqui, no titulo da
                  etiqueta: a um toque de distancia, sem ocupar espaco. */}
              <span
                className="ceo-hoje-tag"
                title={`O dia vira a meia-noite de ${dados.fuso || 'Sao Paulo'}`}
              >
                hoje · {dataBR(dados.hoje)}
              </span>
              <div className="ceo-hoje-nums">
                <div className="ceo-hoje-num">
                  <div className="k">Vendas</div>
                  <div className="v">{dados.hojeNumeros.vendas}</div>
                </div>
                <div className="ceo-hoje-num pos">
                  <div className="k">Total</div>
                  <div className="v">{brl(dados.hojeNumeros.receita)}</div>
                </div>
                <div className="ceo-hoje-num">
                  <div className="k">Contas</div>
                  <div className="v">{dados.hojeNumeros.contas}</div>
                </div>
              </div>
            </div>

            <div className="ceo-kpis">
              <Kpi
                k="Receita (periodo)" tom="pos" v={brl(dados.periodo.receita)}
                sub={`${dados.periodo.vendas} venda(s)${dados.periodo.desde
                  ? ` · desde ${dataCurta(dados.periodo.desde)}` : ' · desde o inicio'}`}
              />
              <Kpi
                k="Receita total" tom="pos" v={brl(dados.total.receita)}
                sub={`${dados.total.vendas} venda(s) · ${t.periodosArquivados} periodo(s) arquivado(s)`}
              />
            </div>

            <h2 className="ceo-secao">Contas</h2>
            {/* ⚠️ `c3`, e nao `auto-fit`: com seis blocos o auto-fit quebrava
                em 4+2 e esticava o ultimo na largura toda. E a armadilha 10 do
                projeto, a mesma do botao orfao na home. */}
            <div className="ceo-kpis c3">
              <Kpi k="Contas" v={t.contas} sub={`${t.contasPremium} premium · ${t.contasGratis} free`} />
              <Kpi k="Conversao" v={`${(t.conversao * 100).toFixed(1)}%`}
                sub={`${t.vendas} pagas · ${t.concedidos} concedidas`} />
              <Kpi k="Com WhatsApp" v={t.comWhatsapp} sub="da para achar no suporte" />
              <Kpi k="Pix em aberto" v={t.pagamentosPendentes} tom={t.pagamentosPendentes ? 'warn' : ''}
                sub={`${t.pagamentosPagos} confirmados`} />
              <Kpi k="Saves na nuvem" v={t.savesNaNuvem}
                sub={`${(t.bytesNaNuvem / 1024 / 1024).toFixed(1)} MB`} />
              <Kpi k="Preco de hoje" v={brl(t.preco)} tom={dados.promo ? 'warn' : ''}
                sub={dados.promo ? 'promocao no ar' : 'preco cheio'} />
            </div>

            {!dados.pagamentoConfigurado && (
              <div className="card tight warn small">
                Pagamento nao configurado neste servidor: nada pode ser vendido.
              </div>
            )}

            {/* Daqui para baixo tudo comeca FECHADO. A aba Operacao e a que
                ele abre todo dia, e o que ele quer ver e o topo: receita e
                contas. Busca, suporte e graficos sao ferramentas que se usam
                quando ha um motivo -- deixa-las abertas empurrava os numeros
                para longe e transformava a aba numa rolagem sem fim. */}
            <details className="card ceo-dobra">
              <summary><span>Buscar usuario</span></summary>
              <div className="ceo-dobra-corpo">
              <div className="small dim" style={{ marginBottom: 9 }}>
                Por e-mail, nome ou WhatsApp. O numero pode vir como a pessoa mandar:
                (17) 99999-8044 acha o mesmo cadastro de +5517999998044.
              </div>
              <div className="row" style={{ gap: 7 }}>
                <input value={termo} onChange={(e) => setTermo(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') buscar(); }}
                  placeholder="e-mail, nome ou WhatsApp" />
                <button className="primary sm" disabled={busy || termo.trim().length < 3} onClick={buscar}>
                  buscar
                </button>
              </div>
              {achados && (
                <div style={{ marginTop: 10 }}>
                  <div className="small dim" style={{ marginBottom: 6 }}>
                    {achados.total} conta(s){achados.total > 20 ? ' — mostrando as 20 primeiras' : ''}
                  </div>
                  {achados.contas.map((c) => (
                    <LinhaConta key={c.email} c={c} busy={busy}
                      onGrant={alternarPremium} onSenha={trocarSenhaDe} />
                  ))}
                  {!achados.total && <div className="dim small">Ninguem com esse dado.</div>}
                </div>
              )}
              </div>
            </details>

            <details className="card ceo-dobra">
              <summary><span>Suporte rapido</span></summary>
              <div className="ceo-dobra-corpo">
                <div className="small dim" style={{ marginBottom: 9 }}>
                  Liberar premium na mao -- para quem pagou e o webhook falhou.
                </div>
                <div className="row" style={{ gap: 7 }}>
                  <input value={alvo} onChange={(e) => setAlvo(e.target.value)} placeholder="email@dominio.com" />
                  <button className="primary sm" disabled={busy || !alvo.includes('@')}
                    onClick={() => acao(() => ceoGrant(token(), alvo.trim().toLowerCase(), true), 'Premium liberado.')}>
                    liberar
                  </button>
                </div>
              </div>
            </details>

            <details className="card ceo-dobra">
              <summary>
                <span>Contas por dia</span>
                <span className="ceo-dobra-n">{dados.dias.length}</span>
              </summary>
              <div className="ceo-dobra-corpo">
              {dados.dias.length ? (
                <>
                  <div className="ceo-bars">
                    {dados.dias.map((d) => (
                      <div key={d.dia} className="ceo-bar"
                        title={`${dataBR(d.dia)}: ${d.contas} conta(s), ${d.premium} venda(s)`}>
                        <div className="col">
                          <div className="pre" style={{ height: `${(d.premium / maxDia) * 100}%` }} />
                          <div className="tot" style={{ height: `${((d.contas - d.premium) / maxDia) * 100}%` }} />
                        </div>
                        <span className="lb">{d.dia.slice(8)}</span>
                      </div>
                    ))}
                  </div>
                  <div className="row" style={{ gap: 12, marginTop: 8 }}>
                    <span className="small dim"><i className="dot tot" /> contas</span>
                    <span className="small dim"><i className="dot pre" /> vendas</span>
                  </div>
                </>
              ) : <div className="dim small">Ainda sem dados.</div>}
              </div>
            </details>

            <details className="card ceo-dobra">
              <summary>
                <span>Receita por mes</span>
                <span className="ceo-dobra-n">{dados.receitaPorMes.length}</span>
              </summary>
              <div className="ceo-dobra-corpo">
              {dados.receitaPorMes.length ? (
                <div className="grid" style={{ gap: 6 }}>
                  {dados.receitaPorMes.map((m) => (
                    <div key={m.mes} className="ceo-month">
                      <span className="mes">{mesNome(m.mes)}</span>
                      <div className="barra"><div style={{ width: `${(m.receita / maxMes) * 100}%` }} /></div>
                      <span className="val tabular">{brl(m.receita)}</span>
                      <span className="qtd dim">{m.vendas}x</span>
                    </div>
                  ))}
                </div>
              ) : <div className="dim small">Nenhuma venda ainda.</div>}
              </div>
            </details>

            {dados.arquivo.length > 0 && (
              <details className="card ceo-dobra">
                <summary>
                  <span>Historico de receita</span>
                  <span className="ceo-dobra-n">{dados.arquivo.length}</span>
                </summary>
                <div className="ceo-dobra-corpo">
                  <div className="small dim" style={{ marginBottom: 8 }}>
                    Periodos fechados pelo botao "zerar receita".
                  </div>
                  {dados.arquivo.map((a) => (
                    <div key={a.fim} className="row spread small" style={{ padding: '5px 0' }}>
                      <span>{dataCurta(a.inicio)} → {dataCurta(a.fim)}</span>
                      <span><b>{brl(a.receita)}</b> <span className="dim">· {a.vendas}x</span></span>
                    </div>
                  ))}
                </div>
              </details>
            )}

            {/* ⚠️ AS DUAS LISTAS COMECAM FECHADAS.
                Elas sao longas e ficam no fim da aba mais usada: abertas, o
                painel vira uma rolagem sem fim e os numeros do topo -- que sao
                o que se olha todo dia -- ficam longe de qualquer outra coisa.
                Quem precisa de uma venda especifica abre; quem so quer o
                resumo do dia nao paga por isso.

                `<details>` nativo, e nao estado no React: ele ja vem com
                teclado e leitor de tela funcionando, e fecha sozinho ao
                recarregar, que e o padrao pedido. */}
            {dados.vendasRecentes.length > 0 && (
              <details className="card ceo-dobra">
                <summary>
                  <span>Ultimas vendas</span>
                  <span className="ceo-dobra-n">{dados.vendasRecentes.length}</span>
                </summary>
                <div className="ceo-dobra-corpo">
                  {dados.vendasRecentes.map((v) => (
                    <div key={v.email + v.at} className="row spread small" style={{ padding: '5px 0' }}>
                      <span style={{ overflowWrap: 'anywhere' }}>{v.nome || v.email}</span>
                      <span className="dim">{dataHora(v.at)} · {brl(v.valor)}</span>
                    </div>
                  ))}
                </div>
              </details>
            )}

            <details className="card ceo-dobra">
              <summary>
                <span>Contas recentes</span>
                <span className="ceo-dobra-n">{dados.contasRecentes.length}</span>
              </summary>
              <div className="ceo-dobra-corpo">
                {dados.contasRecentes.map((c) => (
                  <LinhaConta key={c.email} c={c} busy={busy}
                    onGrant={alternarPremium} onSenha={trocarSenhaDe} />
                ))}
              </div>
            </details>
          </>
        )}

        {/* ---------------------------------------------- CONTROLE DO JOGO */}
        {dados && aba === 'game' && (
          <>
            <div className="card">
              <h3>Preco do premium</h3>
              <div className="small dim" style={{ marginBottom: 9 }}>
                Vale para as proximas cobrancas -- a Efi passa a cobrar este valor.
                Nao mexe em quem ja comprou.
              </div>
              <div className="row" style={{ gap: 7 }}>
                <input type="number" step="0.01" value={preco} onChange={(e) => setPreco(e.target.value)} />
                <button className="primary sm" disabled={busy || !(Number(preco) > 0)}
                  onClick={() => acao(() => ceoConfig(token(), { preco: Number(preco), ligasGratis: gratis }), 'Preco publicado.')}>
                  publicar
                </button>
              </div>
            </div>

            <div className="card">
              <h3>Ligas gratis</h3>
              <div className="small dim" style={{ marginBottom: 9 }}>
                As demais abrem com o premium. Pelo menos uma precisa ficar gratis.
              </div>
              <div className="grid" style={{ gap: 7 }}>
                {LEAGUE_LIST.map((l) => {
                  const on = gratis.includes(l.id);
                  return (
                    <button key={l.id} className={`club ${on ? 'on' : ''}`}
                      onClick={() => setGratis(on
                        ? (gratis.length > 1 ? gratis.filter((x) => x !== l.id) : gratis)
                        : [...gratis, l.id])}>
                      <div className="row spread">
                        <span className="nm">{l.name}</span>
                        <span className={`pill ${on ? 'on' : ''}`}>{on ? 'gratis' : 'premium'}</span>
                      </div>
                      <div className="small dim">{l.blurb}</div>
                    </button>
                  );
                })}
              </div>
              <button className="primary" style={{ width: '100%', marginTop: 10 }} disabled={busy}
                onClick={() => acao(() => ceoConfig(token(), { preco: Number(preco), ligasGratis: gratis }), 'Publicado.')}>
                publicar
              </button>
            </div>

            <div className="card">
              <h3>Pagamento</h3>
              <div className="grid two small">
                <div className="row spread"><span className="dim">Estado</span>
                  <b className={dados.pagamentoConfigurado ? 'pos' : 'neg'}>
                    {dados.pagamentoConfigurado ? 'configurado' : 'desligado'}
                  </b>
                </div>
                <div className="row spread"><span className="dim">Ambiente</span><b>{dados.ambiente}</b></div>
                <div className="row spread"><span className="dim">Preco base</span><b>{brl(t.precoBase)}</b></div>
                <div className="row spread"><span className="dim">Cobrando hoje</span><b>{brl(t.preco)}</b></div>
              </div>
              <div className="dim small" style={{ marginTop: 8 }}>
                As credenciais ficam no ambiente do servidor, nunca aqui.
              </div>
            </div>
          </>
        )}

        {/* -------------------------------------------------------- AVISOS */}
        {dados && aba === 'avisos' && (
          <div className="card">
            <h3>Recado para os jogadores</h3>
            <div className="small dim" style={{ marginBottom: 10 }}>
              Aparece UMA vez para cada jogador, na tela inicial. Para algo que
              precisa ficar no ar, use a aba "Tela inicial".
            </div>
            <input value={avisoTitulo} onChange={(e) => setAvisoTitulo(e.target.value)}
              placeholder="Titulo (ex: Nova temporada)" maxLength={80} />
            <textarea
              value={avisoTexto} onChange={(e) => setAvisoTexto(e.target.value)}
              placeholder="O que voce quer contar" maxLength={600} rows={4}
              style={{ marginTop: 8, resize: 'vertical' }}
            />
            <div className="row wrap" style={{ gap: 8, marginTop: 10 }}>
              <button className="primary" style={{ flex: 1 }} disabled={busy || !avisoTexto.trim()}
                onClick={() => acao(() => ceoAviso(token(), {
                  titulo: avisoTitulo, texto: avisoTexto, ativo: true,
                }), 'Recado publicado.')}>
                publicar recado
              </button>
              <button className="danger" disabled={busy}
                onClick={() => acao(() => ceoAviso(token(), { ativo: false }), 'Recado retirado.')}>
                tirar do ar
              </button>
            </div>
            {dados.aviso && (
              <div className="card tight" style={{ marginTop: 12, borderColor: 'var(--accent)' }}>
                <div className="small dim">No ar desde {dataHora(dados.aviso.at)}</div>
                <div style={{ fontWeight: 700, marginTop: 3 }}>{dados.aviso.titulo}</div>
                <div className="small">{dados.aviso.texto}</div>
              </div>
            )}
          </div>
        )}

        {/* -------------------------------------------------- TELA INICIAL */}
        {dados && aba === 'home' && (
          <div className="card">
            <h3>Chamada da tela inicial</h3>
            <div className="small dim" style={{ marginBottom: 10 }}>
              Fica na home ate voce tirar. Diferente do recado, que some depois
              de a pessoa ler uma vez.
            </div>
            <input value={homeTitulo} onChange={(e) => setHomeTitulo(e.target.value)}
              placeholder="Titulo curto" maxLength={60} />
            <textarea value={homeTexto} onChange={(e) => setHomeTexto(e.target.value)}
              placeholder="Uma ou duas linhas" maxLength={300} rows={3}
              style={{ marginTop: 8, resize: 'vertical' }} />
            <div className="row wrap" style={{ gap: 8, marginTop: 10 }}>
              <button className="primary" style={{ flex: 1 }} disabled={busy || !homeTexto.trim()}
                onClick={() => acao(() => ceoTelaInicial(token(), {
                  titulo: homeTitulo, texto: homeTexto, ativo: true,
                }), 'Chamada publicada.')}>
                publicar
              </button>
              <button className="danger" disabled={busy}
                onClick={() => acao(() => ceoTelaInicial(token(), { ativo: false }), 'Chamada retirada.')}>
                tirar do ar
              </button>
            </div>
            {dados.telaInicial && (
              <div className="card tight" style={{ marginTop: 12, borderColor: 'var(--accent)' }}>
                <div className="small dim">No ar desde {dataHora(dados.telaInicial.at)}</div>
                <div style={{ fontWeight: 700, marginTop: 3 }}>{dados.telaInicial.titulo}</div>
                <div className="small">{dados.telaInicial.texto}</div>
              </div>
            )}
          </div>
        )}

        {/* ----------------------------------------------------- PROMOCOES */}
        {dados && aba === 'promo' && (
          <div className="card">
            <h3>Promocao</h3>
            <div className="small dim" style={{ marginBottom: 10 }}>
              Enquanto estiver no ar, a Efi cobra o preco promocional. Passada a
              data, o preco volta sozinho ao cheio -- sem voce precisar lembrar.
            </div>
            <label className="small dim">Preco promocional</label>
            <input type="number" step="0.01" value={promoPreco}
              onChange={(e) => setPromoPreco(e.target.value)} placeholder="9.90" />
            <label className="small dim" style={{ marginTop: 8, display: 'block' }}>Ate o dia (inclusive)</label>
            <input type="date" value={promoAte} onChange={(e) => setPromoAte(e.target.value)} />
            <label className="small dim" style={{ marginTop: 8, display: 'block' }}>Chamada (opcional)</label>
            <input value={promoTexto} onChange={(e) => setPromoTexto(e.target.value)}
              placeholder="ex: so ate domingo" maxLength={120} />
            <div className="row wrap" style={{ gap: 8, marginTop: 10 }}>
              <button className="primary" style={{ flex: 1 }} disabled={busy || !(Number(promoPreco) > 0)}
                onClick={() => acao(() => ceoPromo(token(), {
                  preco: Number(promoPreco), ate: promoAte, texto: promoTexto, ativo: true,
                }), 'Promocao no ar.')}>
                publicar promocao
              </button>
              <button className="danger" disabled={busy}
                onClick={() => acao(() => ceoPromo(token(), { ativo: false }), 'Promocao encerrada.')}>
                encerrar
              </button>
            </div>
            {dados.promo && (
              <div className="card tight" style={{ marginTop: 12, borderColor: 'var(--accent)' }}>
                <div style={{ fontWeight: 700 }}>{brl(dados.promo.preco)}</div>
                <div className="small dim">
                  {dados.promo.ate ? `ate ${dados.promo.ate}` : 'sem prazo'}
                  {dados.promo.texto ? ` · ${dados.promo.texto}` : ''}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ------------------------------------------------------ ENQUETES */}
        {dados && aba === 'enquete' && (
          <>
            <div className="card">
              <h3>Perguntar aos jogadores</h3>
              <div className="small dim" style={{ marginBottom: 10 }}>
                Aparece na tela inicial de quem tem conta. Publicar de novo apaga
                os votos: pergunta nova com resposta velha nao quer dizer nada.
              </div>
              <input value={pergunta} onChange={(e) => setPergunta(e.target.value)}
                placeholder="ex: qual liga voce quer que entre depois?" maxLength={140} />
              {opcoes.map((o, i) => (
                <input key={i} value={o} style={{ marginTop: 7 }} maxLength={60}
                  placeholder={`opcao ${i + 1}${i > 1 ? ' (opcional)' : ''}`}
                  onChange={(e) => setOpcoes(opcoes.map((x, j) => (j === i ? e.target.value : x)))} />
              ))}
              <div className="row wrap" style={{ gap: 8, marginTop: 10 }}>
                <button className="primary" style={{ flex: 1 }}
                  disabled={busy || !pergunta.trim() || opcoes.filter((o) => o.trim()).length < 2}
                  onClick={() => acao(() => ceoEnquete(token(), {
                    pergunta, opcoes: opcoes.filter((o) => o.trim()), ativo: true,
                  }), 'Enquete publicada.')}>
                  publicar enquete
                </button>
                <button className="danger" disabled={busy}
                  onClick={() => acao(() => ceoEnquete(token(), { ativo: false }), 'Enquete encerrada.')}>
                  encerrar
                </button>
              </div>
            </div>

            {dados.enquete && (
              <div className="card">
                <h3>Apuracao</h3>
                <div className="small dim" style={{ marginBottom: 9 }}>
                  {dados.enquete.pergunta} · {dados.enquete.total} voto(s)
                </div>
                <div className="grid" style={{ gap: 6 }}>
                  {dados.enquete.apuracao.map((o) => (
                    <div key={o.texto} className="ceo-month">
                      <span className="mes">{o.texto}</span>
                      <div className="barra"><div style={{ width: `${(o.votos / votosMax) * 100}%` }} /></div>
                      <span className="val tabular">{o.votos}</span>
                      <span className="qtd dim">
                        {dados.enquete.total ? `${Math.round((o.votos / dados.enquete.total) * 100)}%` : '0%'}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}

        {/* ---------------------------------------------------------- BUGS */}
        {dados && aba === 'bugs' && (
          <div className="card">
            <h3>Relatos dos jogadores</h3>
            <div className="small dim" style={{ marginBottom: 10 }}>
              Chegam pelo botao "Relatar problema" na tela inicial. Os 30 mais recentes.
            </div>
            {dados.bugs.length ? dados.bugs.map((b) => (
              <div key={b.id} className={`ceo-bug ${b.resolvido ? 'ok' : ''}`}>
                <div style={{ minWidth: 0, flex: '1 1 auto' }}>
                  <div className="small" style={{ overflowWrap: 'anywhere' }}>{b.texto}</div>
                  <div className="ceo-user-s">
                    {dataHora(b.at)}
                    {b.email ? ` · ${b.email}` : ' · sem conta'}
                    {b.tela ? ` · ${b.tela}` : ''}
                    {b.versao ? ` · build ${String(b.versao).slice(0, 12)}` : ''}
                  </div>

                  {/* O print vem do servidor, nao do relato: ele mora em
                      arquivo, fora do store.json. */}
                  {b.temImagem && <PrintDoRelato id={b.id} />}

                  {/* ⚠️ O diagnostico fica FECHADO. Ele responde "da para
                      reproduzir?" e por isso vale ouro -- mas e um bloco de
                      JSON, e aberto ele afogaria o texto do relato, que e o
                      que se le primeiro. */}
                  {b.diag && (
                    <details className="ceo-bug-diag">
                      <summary>diagnostico</summary>
                      <pre>{(() => {
                        try { return JSON.stringify(JSON.parse(b.diag), null, 2); }
                        catch { return b.diag; }
                      })()}</pre>
                    </details>
                  )}
                </div>
                <button className="ghost sm" disabled={busy}
                  onClick={() => acao(() => ceoBug(token(), b.id, !b.resolvido),
                    b.resolvido ? 'Reaberto.' : 'Marcado como resolvido.')}>
                  {b.resolvido ? 'reabrir' : 'resolvido'}
                </button>
              </div>
            )) : <div className="dim small">Nenhum relato ainda.</div>}
          </div>
        )}

        <div style={{ height: 26 }} />
      </div>
    </>
  );
}
